import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** tailwind-merge должен знать свои размеры текста и тени, иначе `text-display` спорит с `text-ink`. */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['display'],
      shadow: ['dialog'],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
